import { ReactNode, Suspense, lazy } from 'react';
import { Box, Text, Flex, Image, Link as ChakraLink, useBreakpointValue } from '@chakra-ui/react';
import Logo from '@/assets/svg/logo.svg';
import { Link } from 'react-router-dom';
const Slider = lazy(() => import('@/components/common/Slider'));
import SliderSkeleton from '@/components/common/Slider/SliderSkeleton';

const AuthWrapper = ({ children }: { children: ReactNode }) => {
  const showSlider = useBreakpointValue({ base: false, lg: true });

  return (
    <Box display="flex" height="100vh" width="100vw">
      {/* left */}
      <Flex
        flex="1"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        p={{ base: 0, lg: 4 }}
        position="relative"
        backgroundImage="url('/src/assets/png/background-images/background-pattern.png')"
        backgroundSize={{ base: '85vw', lg: '30vw' }}
        backgroundPosition={'center top'}
        backgroundRepeat="no-repeat"
      >
        <Box
          as="button"
          position="absolute"
          top={{ base: '16px', lg: '24px' }}
          left={{ base: '16px', lg: '24px' }}
          p={'sm'}
          flexShrink={0}
        >
          {/* logo starts */}
          <Link to="/">
            <Image
              src={Logo}
              alt="Logo"
              width={{ base: '115px', lg: '170px' }}
              height={'auto'}
              objectFit={'cover'}
            />
          </Link>
          {/* logo ends */}
        </Box>
        {children}
        <Box position="absolute" bottom={6} textAlign="center" width="100%">
          <Text fontSize="xs" color="#475467" fontWeight="normal" fontFamily="primary">
            By creating an account, you agree to our{' '}
            <Text
              as="span"
              color="#475467"
              textDecoration={'underline'}
              _hover={{
                color: 'brand.primary.DEFAULT',
              }}
            >
              <ChakraLink href="https://kurtasari.com/terms-and-conditions" isExternal>
                terms of use
              </ChakraLink>
            </Text>
            .
          </Text>
        </Box>
      </Flex>

      {/* right slider */}
      <Box flex="1" display={{ base: 'none', lg: 'block' }} bg="white" p={'24px'} overflow="hidden">
        {showSlider && (
          <Suspense fallback={<SliderSkeleton />}>
            <Slider />
          </Suspense>
        )}
      </Box>
    </Box>
  );
};

export default AuthWrapper;
